import React from 'react';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'gold' | 'outline';
}
export function CTAButton({
  children,
  className = '',
  variant = 'primary',
  ...props
}: CTAButtonProps) {
  const handleClick = () => {
    const section = document.getElementById('investment');
    if (section) {
      section.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const baseStyles = 'relative overflow-hidden block w-full text-center px-6 py-[18px] text-[14px] md:text-[15px] font-medium tracking-[0.04em] transition-all duration-200 focus:outline-none rounded-[4px]';
  const variants = {
    primary: 'bg-plum text-white hover:bg-plum-deep',
    gold: 'bg-gold text-plum-deep font-semibold hover:bg-gold-light rounded-[6px]',
    outline: 'bg-transparent text-plum border-[1.5px] border-plum hover:bg-plum/5'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className} group active:scale-[0.98]`} onClick={handleClick} {...props} data-id="element-235">
      <span className="relative z-10" data-id="element-236">{children}</span>
      {variant !== 'outline' && <div className="absolute inset-0 z-0 bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.12),transparent)] bg-[length:200%_100%] animate-shimmer" data-id="element-237" />}
    </button>;
}